import React from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

export default function Notification({ message, type, onClose }) {
  if (!message) return null;
  const alertClass =
    type === "success"
      ? "alert-success"
      : type === "warning"
      ? "alert-warning"
      : "alert-danger";
  return createPortal(
    <div
      className={`alert ${alertClass} alert-dismissible`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        margin: 0,
        borderRadius: 0,
        textAlign: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
      role="alert"
    >
      {message}
      <button
        type="button"
        className="close-alert"
        onClick={onClose}
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>,
    document.body
  );
}

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
